import { Box, Divider, Typography } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { Paragraph, SectionTitle } from "./components"

const TermsSubtitle = styled(SectionTitle).attrs({
  mb: 2,
  textAlign: "left",
})`
  font-weight: normal;
  letter-spacing: 1.25px;
  text-transform: capitalize;
`
const TermText = styled(Paragraph)`
  letter-spacing: 0.5px;
  margin-bottom: 16px;
`

const VipTermsConditions = () => (
  <Box contain mb={10} px={{ _: "10px", tablet: 2 }}>
    <SectionTitle mb={2} textAlign="left">
      General
    </SectionTitle>
    <TermsSubtitle>1.1 Overview</TermsSubtitle>
    <TermText>
      These terms and conditions (
      <strong>&quot;Terms and Conditions&quot;</strong>) govern &quot;JEWLRVIP
      Loyalty Program&quot;, a loyalty program offered by JEWLR (the{" "}
      <strong>&quot;Company&quot;</strong>, <strong>&quot;us&quot;</strong>,{" "}
      <strong>&quot;our&quot;</strong> or <strong>&quot;we&quot;</strong>) . The
      Program is accessible through www.jewlr.com (the{" "}
      <strong>&quot;Program Website&quot;</strong>) and any other related sites.{" "}
      <br />
      To become a Member (<strong>&quot;Member&quot;</strong>) of the program
      but you must establish an account in order to participate and earn
      rewards. No purchase is necessary.
      <br />A Member will earn Jewls in connection with the purchase of
      qualifying online products (
      <strong>&quot;Eligible Purchases&quot;</strong>) and online activities.
      These Jewls are redeemable on the same site towards the purchase of
      certain offers online, benefits and/or rebates offered by the Company
      <br />
      Members acquire no vested right or entitlement to the continued
      availability of any particular reward, benefit or redemption level.
    </TermText>
    <TermsSubtitle>1.2 Terms and Conditions</TermsSubtitle>
    <TermText>
      {" "}
      The terms and conditions set forth herein (the{" "}
      <strong>&quot;Terms & Conditions&quot;</strong>, and together with JEWLR
      Terms and Conditions set for on the Company website, the Explainer Page
      and any other terms accessible through any of the foregoing, collectively
      the <strong>&quot;Program Terms&quot;</strong>) govern the Program. The
      Company in its sole discretion can, restrict, suspend, amend, extend or
      otherwise alter the Program Terms at any time and without prior notice. If
      the Program Terms have been updated, the Company will post the new Program
      Terms on the Website and note the date that they were last updated. We
      encourage Members to review the Program Terms each time they use the
      Program.
    </TermText>

    <TermsSubtitle>1.3 Acceptance</TermsSubtitle>
    <TermText>
      By using or enrolling in the Program, you accept and agree to be bound by
      these Terms and Conditions.
    </TermText>

    <Divider bg={"#ebebec"} my={3} />
    <SectionTitle mb={2} textAlign="left">
      Program Membership
    </SectionTitle>
    <TermsSubtitle>2.1 Membership Enrollment</TermsSubtitle>
    <TermText>
      Membership is free and no initial purchase is required. To become a valid
      Member, you must complete the enrolment process at{" "}
      <Typography
        as={Link}
        color="primary"
        data-lc="vip-terms-conditions"
        fontSize="14px"
        to="/signup"
      >
        https://{sl.config.site_url}/signup
      </Typography>{" "}
      by providing complete and accurate information and indicating your
      acceptance of the Program Terms. After completion, you will have a Member
      account. Please see our Privacy Policy, located{" "}
      <Typography as="a" color="primary" fontSize="14px" href="privacy_notice">
        here
      </Typography>
      , to understand how information you provide will be used. This program is
      void where prohibited.
    </TermText>

    <TermsSubtitle>2.2 Passwords and Security</TermsSubtitle>
    <TermText>
      {" "}
      In order to enroll in the Program, you will have have an Account with us
      and provide one or more names, email addresses, login usernames and
      passwords (together, <strong>&quot;ID&quot;</strong>). You are responsible
      for maintaining the confidentiality of your ID. You agree not to use the
      ID of any third party or disclose your ID to any third party. You are
      responsible for any and all activity that occurs on your Account. If you
      suspect any unauthorized use of your Account, you must notify us
      immediately. You agree to provide us with correct and complete Account
      information at all times and inform us of any changes to the information
      you have provided. We will keep your ID confidential. Only one{" "}
      <strong>JEWLR REWARDS</strong> account (
      <strong>&quot;Account&quot;</strong>) is permitted per person.
    </TermText>

    <TermsSubtitle>
      2.3 Change Information; Suspension Rights; Capacity
    </TermsSubtitle>
    <TermText>
      Members are responsible to update their account immediately if there is
      any change to their address or other contact information. The Company will
      not be responsible for any communication not received by a Member,
      provided that the Company sent such communication to the address or other
      contact information then on file from such Member. To make any changes or
      update to your contact information you can do so{" "}
      <Typography
        as={Link}
        color="primary"
        data-lc="vip-terms-conditions"
        fontSize="14px"
        to="/account/preferences"
      >
        here
      </Typography>
      .
    </TermText>

    <TermsSubtitle>2.4 Suspension Rights; Capacity</TermsSubtitle>
    <TermText>
      If the Company determines that a Member has abused any of the Program’s
      privileges, fails to comply with any of the Program Terms, or makes any
      misrepresentation to the Company the Company may, in its sole discretion,
      take such actions as it deems appropriate, including without limitation,
      suspending such Member’s privileges under the Program, revoking any or all
      of the Jewls in such Member’s Account, and/or revoking the Member’s
      membership in the Program, in each case, with or without advance notice to
      the Member and without liability to the Company.
      <br />
      Jewls will not be awarded if in the Company’s reasonable opinion the
      merchandise purchased will be used for resale or commercial use and any
      Jewls awarded on such purchases will be forfeited. If a Member was awarded
      Jewls for an offer or promotion in which a Member purchased product(s) in
      excess of reasonable quantities, the Jewls awarded as a result of that
      offer or promotion may be forfeited without prior notice and the Account
      may be suspended or closed. <br />
      Unless further restricted elsewhere in the Program Terms, Membership is
      only available to (i) individuals above the age of majority and who have
      legal capacity, have Internet access, a valid email address and have a
      valid mailing address. If a Member does not meet the requirements set out
      above, all Jewls awarded to such Member may be forfeited without prior
      notice and the Account may be suspended or closed.
    </TermText>

    <TermsSubtitle>2.5 Inactive Accounts and Unused Jewls</TermsSubtitle>
    <TermText>
      {" "}
      A Member Account is deemed to be inactive if Jewls are not earned in
      connection with such Account for 12 months. Once an Account is deemed to
      be inactive, all Jewls in such Account may, in the Company&apos;s sole
      discretion, be deemed to have been forfeited by such Member, with or
      without notice.
      <br />
      Jewls will expire after 365 days.
    </TermText>

    <TermsSubtitle>2.6 Security</TermsSubtitle>
    <TermText>
      If a Member&apos;s Jewls are used by any other person, all Jewls relating
      to purchases made by such other person will be credited to the same Member
      Account. The Company assumes no liability or responsibility for Jewls
      redeemed by any person(s) prior to a notification to the Company&apos;s
      Customer Service Centre that the Member Account has been compromised. Any
      Jewls redeemed prior to notification shall be at the Member’s risk.
    </TermText>

    <Divider bg={"#ebebec"} my={3} />
    <SectionTitle mb={2} textAlign="left">
      Reward Jewls
    </SectionTitle>
    <TermsSubtitle>3.1 Collection; Redemption</TermsSubtitle>
    <TermText>
      {" "}
      Jewls can be earned by Members in connection with qualifying purchases
      through the Company online website as set forth on{" "}
      <Typography
        as={Link}
        color="primary"
        data-lc="vip-terms-conditions"
        fontSize="14px"
        to="/vip-rewards"
      >
        https://{sl.config.site_url}/vip-rewards
      </Typography>
      , regardless of method of payment provided that the Member is logged in at
      the time of purchase.
      <br />
      Jewls can be redeemed for rewards in the country and currency in which
      they were earned only. When enough Jewls have been accumulated to be
      eligible to be redeemed, redemption may occur online during Checkout as
      long as you are logged in. The redemption schedule, available rewards and
      other information is available on at{" "}
      <Typography
        as={Link}
        color="primary"
        data-lc="vip-terms-conditions"
        fontSize="14px"
        to="/vip-rewards"
      >
        https://{sl.config.site_url}/vip-rewards
      </Typography>
      .<br />
      A Member must be logged in when redeeming Jewls to protect the integrity
      of the Member’s balance. Each Member is responsible to ensure that all
      Personal Information is correct and up-to-date and the Company reserves
      the right to block redemptions where the Member information is inaccurate
      or incomplete. Members are solely and entirely responsible for keeping
      their Account secure.
      <br />
      The minimum number of Jewls eligible for redemption is 3000 Jewls.
      <br />
      The maximum Jewls to be used on any one transaction is 80000 Jewls.
    </TermText>

    <TermsSubtitle>3.2 Value</TermsSubtitle>
    <TermText>
      Jewls have no cash value and are not exchangeable for cash. The
      accumulation of Jewls does not entitle a Member to any vested rights, and
      the Company does not guarantee in any way the continued availability of
      any reward, redemption level, rebate or any other benefit. The Company
      assumes no liability to Members as regards the addition or deletion of
      items from or for which Jewls can be collected and/or redeemed.
    </TermText>

    <TermsSubtitle>3.3 Transferability</TermsSubtitle>
    <TermText>
      Jewls cannot be assigned, exchanged, traded, bartered, purchased or given
      by gift or otherwise sold. Any Jewls so acquired are void. For the
      avoidance of doubt, such prohibited transfers include transfers upon
      operation or law upon the death of a Member.
    </TermText>

    <TermsSubtitle>3.4 Return/Exchange Policy</TermsSubtitle>
    <TermText>
      {" "}
      In the event of a return/exchange of any eligible purchase that initially
      earned Jewls, such Jewls will be deducted automatically from the Account
      that was used for the eligible purchase. Jewls will be deducted at the
      same rate as they were earned. <br />
      Upon the return and/or exchange of products awarded through the redemption
      of Jewls, all redeemed Jewls will be forfeited.
    </TermText>

    <TermsSubtitle>3.5 Promotion</TermsSubtitle>
    <TermText>
      {" "}
      From time to time, the Company may advertise or offer exclusive offers to
      select Members to redeem Jewls for items other than a discount reward, or
      receive other benefits or discounts.
    </TermText>

    <Divider bg={"#ebebec"} my={3} />
    <SectionTitle mb={2} textAlign="left">
      Privacy
    </SectionTitle>
    <TermsSubtitle>4.1 Confidential Information</TermsSubtitle>
    <TermText>
      {" "}
      We are committed to protecting your privacy. We will maintain the privacy
      and security of all personal information collected from Members,
      including, but not limited to: name, address, email address, telephone
      numbers.(<strong>&quot;Personal Information&quot;</strong>). <br />
      You understand that through your use of the Program, you consent to the
      collection and use of this information. As part of providing you the
      Program, we may need to provide you with certain communications, such as
      service announcements and administrative messages. These communications
      are considered part of the Program and your Account.
    </TermText>
    <TermsSubtitle>4.2 Unsubscribe</TermsSubtitle>
    <TermText>
      {" "}
      By sharing your email address and as an active customer and Member, we
      and/or our service providers may communicate to you special offers,
      services, promotions and program information. You can unsubscribe from
      receiving such messages at any time by clicking unsubscribe at the bottom
      of any promotional email.
    </TermText>

    <Divider bg={"#ebebec"} my={3} />
    <SectionTitle>General</SectionTitle>
    <TermsSubtitle>5.1 Acceptance</TermsSubtitle>
    <TermText>
      {" "}
      By participating in the Program, each Member (i) certifies that he or she
      is over the age of majority in the state or province in which he or she
      resides (or is supervised by a parent or legal guardian who agrees to the
      Program Terms) and of mental capacity (or is supervised by a legal
      guardian who agrees to the Program Terms), (ii) consents to the company’s
      collection and use of certain personal information, except as he or she
      may otherwise notify the Company and (iii) agrees to the Program Terms, as
      they may be amended from time to time.
    </TermText>

    <TermsSubtitle>5.2 Other Terms</TermsSubtitle>
    <TermText>
      These Terms & Conditions are in addition to any other Program Terms, and
      shall be read together with such other Program Terms as one and the same
      instrument; provided, that if there is a conflict between any terms set
      forth in these terms and conditions, the Program Website, the Explainer
      Page and/or any other Program Terms, such conflict shall be resolved as
      follows: first, the Explainer Page shall prevail, thereafter these Terms &
      Conditions, thereafter the Program Website and finally any other Program
      Terms. For the avoidance of doubt, in the event of any action, proceeding
      or other dispute arising from or relating to any Program Terms, such
      dispute shall be settled in accordance with the provisions and procedures
      set forth in these Terms & Conditions.
    </TermText>

    <TermsSubtitle>5.3 Abuse</TermsSubtitle>
    <TermText>
      {" "}
      Any abuse by a Member of the Program’s privileges, any failure by a Member
      to follow these Terms and Conditions, or any misrepresentation by a Member
      may subject the Member to expulsion from the Program, including forfeiture
      of all accumulated Jewls.
    </TermText>

    <TermsSubtitle>5.4 Abuse</TermsSubtitle>
    <TermText>
      {" "}
      Every effort has been made to ensure that the information herein is
      correct. The Company is not responsible for any errors or omissions in
      printed copies of these Terms and Conditions nor those published from time
      to time on its website. <br />
      Any waiver by the Company of the strict observance, performance or
      compliance by a Member with any of the Terms and Conditions contained
      herein, either expressly granted or by course of conduct, shall be
      effective only in the specific instance and shall not be deemed to be a
      waiver of any rights or remedies of the Company as a result of any other
      failure to observe, perform or comply with the Terms and Conditions. No
      delay or omission by the Company in exercising any right or remedy
      hereunder shall operate as waiver thereof or of any other right or remedy.
      <br />
      In the event that any provision in these Terms and Conditions is
      determined to be invalid, illegal, or unenforceable, such determination
      shall not affect the validity and enforceability of any other remaining
      provisions of these Terms and Conditions.
    </TermText>

    <TermsSubtitle>5.5 Contact</TermsSubtitle>
    <TermText>
      {" "}
      If you have any questions about these Terms and Conditions or if you wish
      to provide any feedback with respect to the Program, please contact us at:{" "}
      <Typography
        as="a"
        color="primary"
        href="mailto:rewards@jewlr.com"
        rel="nofollow"
      >
        rewards@jewlr.com
      </Typography>
    </TermText>
  </Box>
)

export default VipTermsConditions
